import type React from 'react';

import { useManageAccessStepper } from '@/hooks/manageAccess/useManageAccessStepper';
import { getManageAccessStepConfig } from '@/components/organism/ManageAccess/stepConfig';

export interface ManageAccessStepperProps {
  onClose: () => void;
}

function ManageAccessStepper(props: ManageAccessStepperProps): React.JSX.Element {
  const { state } = useManageAccessStepper();
  const { component: StepComponent } = getManageAccessStepConfig(state.step);
  return <StepComponent onClose={props.onClose} />;
}

ManageAccessStepper.displayName = 'ManageAccessStepper';

export default ManageAccessStepper;
